'use client';

import { forwardRef, ChangeEvent } from 'react';
import styles from './text-field.module.scss';
import { TextFieldType } from '@/types/contactsBlock.types';

const TextField = forwardRef<HTMLInputElement, TextFieldType>(
  (
    { className = '', label, placeholder, value = '', onChange, error },
    ref
  ) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.value);
    };

    return (
      <div className={[styles.textField, className].join(' ')}>
        <div className={styles.label}>{label}</div>
        <div className={[styles.row, error ? styles.error : ''].join(' ')}>
          <input
            ref={ref}
            className={styles.enterYourEmail}
            placeholder={placeholder}
            type="text"
            value={value}
            onChange={handleChange}
          />
        </div>
        {error && <div className={styles.errorText}>{error}</div>}
      </div>
    );
  }
);

TextField.displayName = 'TextField';

export default TextField;
